import React, { ReactNode, createContext, useContext } from 'react';

/**
 * `fill` — list measures and uses a fixed viewport height (default for full-page overviews).
 * `shrink` — list measures as a max-height cap so short datasets stay compact (stacked detail lists).
 */
export type ObjectListHeightMode = 'fill' | 'shrink';

const ObjectListHeightModeContext = createContext<ObjectListHeightMode>('fill');

interface ObjectListHeightModeProviderProps {
    children: ReactNode;
    mode: ObjectListHeightMode;
}

export const ObjectListHeightModeProvider = (props: ObjectListHeightModeProviderProps) => {
    return <ObjectListHeightModeContext.Provider value={props.mode}>{props.children}</ObjectListHeightModeContext.Provider>;
};

export const useObjectListHeightMode = () => useContext(ObjectListHeightModeContext);
